import util from 'preact-util';

export function emptyFeedPreference() {
    return { followedAuthors: [], followedTopics: [] };
}

function normalizeTopic(value) {
    if (typeof value !== 'string') return null;
    const topic = value.trim().replace(/\s+/g, ' ');
    return topic || null;
}

export function parseFeedPreference(value) {
    const input = value && typeof value === 'object' ? value : {};
    const authors = [...new Set((Array.isArray(input.followedAuthors) ? input.followedAuthors : [])
        .map(authorId => Number(authorId))
        .filter(authorId => Number.isInteger(authorId) && authorId > 0))];
    const topics = [];
    const seenTopics = new Set();
    (Array.isArray(input.followedTopics) ? input.followedTopics : []).forEach(value => {
        const topic = normalizeTopic(value);
        const key = topic?.toLocaleLowerCase('nb-NO');
        if (topic && !seenTopics.has(key)) {
            seenTopics.add(key);
            topics.push(topic);
        }
    });
    return { followedAuthors: authors, followedTopics: topics };
}

export function isTopicFollowed(preference, topic) {
    const target = normalizeTopic(topic)?.toLocaleLowerCase('nb-NO');
    return Boolean(target && parseFeedPreference(preference).followedTopics.some(value => (
        value.toLocaleLowerCase('nb-NO') === target
    )));
}

export function updateFeedPreference(preference, { targetType, targetValue, followed }) {
    const current = parseFeedPreference(preference);
    if (targetType === 'author') {
        const authorId = Number(targetValue);
        if (!Number.isInteger(authorId) || authorId < 1) return current;
        return {
            ...current,
            followedAuthors: followed
                ? [...new Set([...current.followedAuthors, authorId])]
                : current.followedAuthors.filter(value => value !== authorId),
        };
    }
    const topic = normalizeTopic(targetValue);
    if (!topic) return current;
    return {
        ...current,
        followedTopics: followed
            ? parseFeedPreference({ followedTopics: [...current.followedTopics, topic] }).followedTopics
            : current.followedTopics.filter(value => (
                value.toLocaleLowerCase('nb-NO') !== topic.toLocaleLowerCase('nb-NO')
            )),
    };
}

export function articlePreferenceReasons(article, preference) {
    const current = parseFeedPreference(preference);
    const author = current.followedAuthors.includes(Number(article?.user))
        ? (article?.creator || null)
        : null;
    const topics = (Array.isArray(article?.tags) ? article.tags : [])
        .map(tag => normalizeTopic(tag?.name))
        .filter(topic => topic && isTopicFollowed(current, topic));
    return {
        author,
        topics: parseFeedPreference({ followedTopics: topics }).followedTopics,
    };
}

export async function loadFeedPreference({ hostname, fetchApi = util.fetchApi }) {
    try {
        const response = await fetchApi('/api/feedpreferences/', { method: 'GET', publish: false }, {
            hostname,
        });
        if (response?.status !== 200) return null;
        return parseFeedPreference(response.data);
    } catch (error) {
        return null;
    }
}
